export default __webpack_public_path__ + "static/qrcode-b9394a02469a6dde94978d4b7b2fe8ca.png";